import { COACH_GRADE_PREFIX_MAP } from '../constants/coachGrades';

export { COACH_GRADE_PREFIX_MAP };

export const getCoachGradePrefix = (grade) => {
  if (!grade) return 'CCH';
  return (
    COACH_GRADE_PREFIX_MAP[grade] ||
    grade.replace(/[^a-zA-Z0-9]/g, '').substring(0, 3).toUpperCase() ||
    'CCH'
  );
};

export const generateCoachLicenseNumber = (grade) => {
  const year = new Date().getFullYear();
  const prefix = getCoachGradePrefix(grade);
  const randomSegment = Math.random().toString(36).substring(2, 6).toUpperCase();
  return `TBF-${prefix}-${year}-${randomSegment}`;
};

export const isCoachLicenseForGrade = (licenseNumber, grade) => {
  if (!licenseNumber?.trim() || !grade) return false;
  const prefix = getCoachGradePrefix(grade);
  return new RegExp(`^TBF-${prefix}-\\d{4}-`, 'i').test(licenseNumber.trim());
};

export const refreshCoachLicenseNumber = (currentLicenseNumber, grade) => {
  if (!grade) {
    return currentLicenseNumber?.trim() || generateCoachLicenseNumber();
  }
  if (currentLicenseNumber && isCoachLicenseForGrade(currentLicenseNumber, grade)) {
    return currentLicenseNumber.trim();
  }
  return generateCoachLicenseNumber(grade);
};

export const resolveCoachLicenseNumber = (licenseNumber, grade) => {
  const trimmed = licenseNumber?.trim();
  if (trimmed && isCoachLicenseForGrade(trimmed, grade)) {
    return trimmed;
  }
  return generateCoachLicenseNumber(grade);
};
